let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let contentClass = '.what-sets-us-apart';

class WhatSetsUsApart {
  constructor($content, context) {
    let slideIndex = 0;
    let slideTimer;
    const slideDelay = 5;
    let slides;

    if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {
      slides = $('.what-sets-us-apart__image--desktop .item-image', context);
    }
    else {
      slides = $('.what-sets-us-apart__image--mobile .item-image', context);
    }
    const texts = $('.what-sets-us-apart__item', context);
    const bullets = $('.bullet-graphic', context);

    /**
     * Slide animation
     * @param {number} index - the slide's index
     */
    function showSlide(index) {
      if (index === slides.length) {
        slideIndex = 0;
      }
      else if (index < 0) {
        slideIndex = slides.length - 1;
      }
      else {
        slideIndex = index;
      }

      slides.each(function () {
        $(this).removeClass('active');
      });

      texts.each(function () {
        $(this).removeClass('active');
      });

      bullets.each(function () {
        $(this).removeClass('active');
      });

      $(slides[slideIndex]).addClass('active');
      $(texts[slideIndex]).addClass('active');
      $(bullets[slideIndex]).addClass('active');
    }

    /**
     * Reset slide animation.
     */
    function slideReset() {
      window.clearInterval(slideTimer);

      setTimeout(function () {
        slideTimer = window.setInterval(function () {
          showSlide((slideIndex += 1));
        }, slideDelay * 1000);
      }, 10);
    }

    /**
     * Pause/Play slide animation
     * @param {string} action - the slide's index
     */
    function slideAnimationToggle(action) {
      if (action === 'pause') {
        window.clearInterval(slideTimer);
      }
      else {
        showSlide(slideIndex);
        slideReset();
      }
    }

    $(contentClass).on('mouseenter focus', function () {
      slideAnimationToggle('pause');
    });

    $(contentClass).on('mouseleave blur', function () {
      slideAnimationToggle('play');
    });

    bullets.each(function () {
      $(this).on('click', function () {
        let itemIndex = this.getAttribute('data-id');
        showSlide(Number(itemIndex));

        slideAnimationToggle('pause');
      });
    });

    showSlide(slideIndex);
    slideReset();
  }
}

/**
 * Initialize what sets us apart function
 * @param {Object} context Document context.
 */
function init(context) {
  if ($(contentClass).length) {
    $.each($(contentClass), (index, elem) => {
      let whatSetsUsApart = new WhatSetsUsApart(elem, context);
    });
  }
}

if (typeof Drupal === 'undefined') {
  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });
}
else {
  module.exports = {
    attach: function (context, settings) {
      init(context);
    },
  };
}
